import styled from '@emotion/styled';
import { Stack } from '@pairy/pds-react';
import { theme } from '@pairy/styles';

/* V1 DesktopPageIndicator와 동일한 높이/여백 */
export const Wrapper = styled(Stack)`
  width: max-content;
  height: 65px;
  padding: 16px 0;
  background-color: transparent;
`;

/* V1 DesktopPageIndicator와 동일한 현재 페이지 박스 */
export const CurrentPageButton = styled.button`
  min-width: 48px;
  height: 33px;
  padding: 4px 8px;
  border: none;
  background: ${theme.colors.zinc_100};
  border-radius: 4px;
  cursor: pointer;
  transition: 0.15s ease-in-out;

  &:hover {
    background: ${theme.colors.zinc_200};
  }
`;

export const PageInput = styled.input`
  width: 48px;
  padding: 4px 8px;
  border: 1px solid ${theme.colors.skyblue_400};

  /* number input spinner 제거 */
  appearance: textfield;
  border-radius: 6px;
  font-size: ${theme.fontSize.md};
  outline: none;
  text-align: center;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    margin: 0;
    appearance: none;
  }
`;
